<template>
  <b-modal :active.sync="isActiveLocal" has-modal-card @close="fecharModal">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{isEnterpriseActive ? 'Inativar Empresa' : 'Ativar Empresa'}}</p>
        <button class="delete" aria-label="close" @click="fecharModal"></button>
      </header>

      <section
        class="modal-card-body"
        v-if="!isEnterpriseActive"
        style="height: 55vh"
      >
        <b-field label="Data de Início do Contrato">
          <b-datepicker
            v-model="dataInicio"
            placeholder="Selecione a data"
            icon="calendar-today"
          />
        </b-field>

        <b-field label="Data de Fim do Contrato">
          <b-datepicker
            v-model="dataFim"
            placeholder="Selecione a data"
            icon="calendar-today"
          />
        </b-field>
      </section>
      <section class="modal-card-body" v-if="isEnterpriseActive">
        <p class="has-text-weight-bold">
          Você está prestes a inativar a empresa, você tem certeza que deseja
          continuar?
        </p>
      </section>

      <footer class="modal-card-foot">
        <b-button
          type="is-primary"
          @click="ativarEmpresa"
          :loading="loading"
          v-if="!isEnterpriseActive"
        >
          Ativar
        </b-button>
        <b-button
          type="is-danger"
          @click="inativarEmpresa"
          :loading="loading"
          v-if="isEnterpriseActive"
        >
          Inativar
        </b-button>
        <b-button type="is-light" @click="fecharModal">Cancelar</b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import EmpresaService from "@/services/EmpresaService";

export default {
  name: "ModalAtivarEmpresa",
  props: {
    isActive: {
      type: Boolean,
      required: true,
    },
    idEmpresa: {
      type: [Number, String],
      required: true,
    },
    isEnterpriseActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isActiveLocal: this.isActive,
      dataInicio: null,
      dataFim: null,
      loading: false,
    };
  },
  watch: {
    isActive(val) {
      this.isActiveLocal = val;
    },
    isActiveLocal(val) {
      if (!val) {
        this.$emit("close");
      }
    },
  },
  methods: {
    async ativarEmpresa() {
      if (!this.dataInicio || !this.dataFim) {
        this.$buefy.toast.open({
          message: "Preencha as datas corretamente.",
          type: "is-danger",
        });
        return;
      }

      this.loading = true;

      try {
        await EmpresaService.ativarEmpresa(this.idEmpresa, {
          dataInicio: this.dataInicio,
          dataFim: this.dataFim,
        });

        this.$buefy.toast.open({
          message: "Empresa ativada com sucesso.",
          type: "is-success",
        });

      } catch (error) {
        this.$buefy.toast.open({
          message: error.response.data.message || "Erro ao ativar empresa.",
          type: "is-danger",
        });
      } finally {
        this.loading = false;
        this.fecharModal();
      }
    },
    async inativarEmpresa() {
      this.loading = true;

      try {
        await EmpresaService.inativarEmpresa(this.idEmpresa);

        this.$buefy.toast.open({
          message: "Empresa inativada com sucesso.",
          type: "is-success",
        });

      } catch (error) {
        this.$buefy.toast.open({
          message: error.response.data.message ?? "Erro ao inativar empresa.",
          type: "is-danger",
        });
      } finally {
        this.loading = false;
        this.fecharModal();
      }
    },
    fecharModal() {
      this.resetarFormulario();
      this.isActiveLocal = false;
      this.$emit("close");
    },
    resetarFormulario() {
      this.dataInicio = null;
      this.dataFim = null;
      this.loading = false;
    },
  },
};
</script>
